import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../assets/images/arka-saydam-logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faXTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';
import PolicyModal from './PolicyModal';

const Footer = () => {
  const [activePolicy, setActivePolicy] = useState(null);
  const hasAuthToken = typeof window !== 'undefined' && Boolean(localStorage.getItem('authToken'));

  const handleLinkClick = (e) => {
    e.preventDefault();
  };

  return (
    <footer className="pt-8 border-t border-[#e6dbdb] bg-white dark:bg-[#1a1a1a] dark:border-gray-800">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="flex flex-col items-center justify-between gap-6 md:flex-row md:flex-wrap">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary overflow-hidden">
              <img
                src={Logo}
                alt="Bana Bir Tarif Ver Logo"
                className="w-full h-full object-contain"
              />
            </div>
            <span className="text-lg font-bold text-text-main dark:text-white">Bana Bir Tarif Ver</span>
          </Link>

          <div className="flex flex-col items-center gap-3 text-sm font-medium text-text-muted dark:text-gray-400 flex-shrink-0 md:flex-row md:gap-8">
            <Link to={hasAuthToken ? '/in-app/sss' : '/sss'} className="transition-colors hover:text-primary">
              S.S.S
            </Link>
            <Link to="/nasil-calisir" className="transition-colors hover:text-primary">
              Nasıl Çalışır?
            </Link>
            <button type="button" className="transition-colors hover:text-primary" onClick={() => setActivePolicy('kvkk')}>
              KVKK Metni
            </button>
            <button type="button" className="transition-colors hover:text-primary" onClick={() => setActivePolicy('privacy')}>
              Gizlilik Politikası
            </button>
            <button type="button" className="transition-colors hover:text-primary" onClick={() => setActivePolicy('terms')}>
              Kullanım Koşulları
            </button>
            <Link to="/hakkimizda" className="transition-colors hover:text-primary">
              Hakkımızda
            </Link>
            <button type="button" className="transition-colors hover:text-primary" onClick={() => setActivePolicy('contact')}>
              İletişim
            </button>
          </div>

          <div className="flex gap-4 flex-shrink-0">
            <a
              className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-gray-600 transition-colors hover:bg-primary hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-primary dark:hover:text-white"
              href="#!"
              onClick={handleLinkClick}
              aria-label="Facebook Sayfamız"
            >
              <FontAwesomeIcon icon={faFacebookF} className="w-4 h-4" />
            </a>
            <a
              className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-gray-600 transition-colors hover:bg-primary hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-primary dark:hover:text-white"
              href="#!"
              onClick={handleLinkClick}
              aria-label="X (Twitter) Hesabımız"
            >
              <FontAwesomeIcon icon={faXTwitter} className="w-4 h-4" />
            </a>
            <a
              className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-gray-600 transition-colors hover:bg-primary hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-primary dark:hover:text-white"
              href="#!"
              onClick={handleLinkClick}
              aria-label="Instagram Sayfamız"
            >
              <FontAwesomeIcon icon={faInstagram} className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="mt-8 text-center text-xs text-text-muted dark:text-gray-500">
          <p>© 2026 Bana Bir Tarif Ver. Tüm hakları saklıdır.</p>
        </div>
      </div>

      <PolicyModal policyKey={activePolicy} open={!!activePolicy} onClose={() => setActivePolicy(null)} />
    </footer>
  );
};

export default Footer;

